import { render, staticRenderFns } from "./CourseStep.vue?vue&type=template&id=499ba156&scoped=true&"
import script from "./CourseStep.vue?vue&type=script&lang=js&"
export * from "./CourseStep.vue?vue&type=script&lang=js&"
import style0 from "./CourseStep.vue?vue&type=style&index=0&id=499ba156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ba156",
  null
  
)

export default component.exports